import React, { useState, } from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View, Dimensions, } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, TextAlignTokens, BottomBarDLSType, TypographyTypeDLS, ButtonTypeDLS, DividerSizeTokens, InterestBounceType, } from '@voltmoney/schema';
import { ModalAlignmentEnum, } from '@voltmoney/types';
import { Typography } from '../../typography/Typography';
import { addCommasToNumber, } from '../utils';
import { Image } from '../../image/Image';
import { Icon } from '../../icon/Icon';
import { Button } from '../../button/Button';
import BottomSheet from '../BottomSheet';
import { isMobile, isMobileView, } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import BottomBar from '../../bottomBarDLS/bottomBarDLS';
import CustomHeader from '../../customHeader/CustomHeader';
import Space from '../../space/Space';
import Divider from '../../divider/Divider';
import moment from 'moment';
import { LENDER_ID } from "../constants";
// import LottieView from "lottie-react-native";
const InterestRepaymentDetails = ({ height, interestRepaymentData, triggerAction, viewDetailAction, type, backAction, bankDetail, contactSupportAction, isFromTata, learnMoreAction, showButtonLoading, lenderId }) => {
    const [showPayModal, setShowPayModal] = useState(false);
    const [showBreakupModal, setShowBreakupModal] = useState(false);
    const [showPaymentConcentCard, setShowPaymentConcentCard] = useState(false);
    const [showPaymentDeclined, setShowPaymentDeclined] = useState(false);
    const [showSellOffCard, setShowSellOffCard] = useState(false);
    const areOnlyChargesDue = interestRepaymentData.outstandingInterest === 0 && interestRepaymentData.outStandingCharges !== 0;
    let softBreachDate = lenderId.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? 3 : lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? 7 : 7;
    let hardBreachDate = lenderId.toLowerCase() === LENDER_ID.TATA.toLowerCase() ? 15 : lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? 15 : 15;
    const currentMonth = moment().format('MMMM');
    let isMandate = interestRepaymentData.isMandateSetup;
    const [buttonLoading, setButtonLoading] = useState(false);
    const bankaccountNumber = bankDetail.accountNumber.slice(-4);
    const header = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomHeader, { title: 'Statement details', goBackAction: backAction, triggerAction: triggerAction, needHelpAction: contactSupportAction })));
    };
    function convertEpochToCustomFormat(epochTime) {
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const date = new Date(epochTime); // No need to multiply by 1000 for milliseconds
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month}, ${year}`;
    }
    const getDescription = () => {
        switch (type) {
            case InterestBounceType.NORMAL: {
                return (React.createElement(View, { style: isMandate ? styles.bottomNoteContainer : styles.bottomNoteContainerNonMandate },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_WARNING_DLS, size: IconSizeTokens.LG })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Text, { style: { flexShrink: 1 } },
                        React.createElement(Typography, { label: `Ensure balance of `, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        React.createElement(Typography, { label: `₹${addCommasToNumber(interestRepaymentData.totalAmount)} `, typeDLS: TypographyTypeDLS.B2S }),
                        React.createElement(Typography, { label: `in your bank account to avoid penalty charges`, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }))));
            }
            case InterestBounceType.DATE_BREACHED: {
                return (React.createElement(View, { style: styles.bottomNoteContainer },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_WARNING_DLS, size: IconSizeTokens.LG })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Text, { style: { flexShrink: 1 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'We are processing auto-debit.', color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: ' It may take up to 2 business days.Need help?' }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                if (backAction) {
                                    triggerAction(contactSupportAction);
                                }
                            } },
                            React.createElement(View, { style: Platform.OS !== 'web' ? { top: 5 } : {} },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ' Contact us', color: ColorTokens.Primary_100 }))))));
            }
            case InterestBounceType.HARD_DATE_BREACHED: {
                return (React.createElement(View, { style: [styles.bottomNoteContainer, { backgroundColor: '#FFF8F8', }] },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.SM, color: ColorTokens.System_Error })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Text, { style: { flexShrink: 1 } },
                        React.createElement(Typography, { label: `Your interest is still overdue. Need help? `, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                if (contactSupportAction) {
                                    triggerAction(contactSupportAction);
                                }
                            } },
                            React.createElement(View, { style: Platform.OS !== 'web' ? { top: 5 } : {} },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Contact support', color: ColorTokens.Primary_100 }))))));
            }
            case InterestBounceType.BOUNCED: {
                return (React.createElement(View, { style: [styles.bottomNoteContainer, { backgroundColor: '#FFF8F8', }] },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.LG, color: ColorTokens.System_Error })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Text, { style: { flexShrink: 1 } },
                        React.createElement(Typography, { label: `Last auto-debit failed!`, fontSize: FontSizeTokens.XS, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        React.createElement(Typography, { label: ` Pay by`, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        React.createElement(Typography, { label: ` ${hardBreachDate}-${currentMonth}`, fontSize: FontSizeTokens.XS, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        React.createElement(Typography, { label: ` to avoid defaulting.`, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        !areOnlyChargesDue && React.createElement(TouchableOpacity, { onPress: () => {
                                if (learnMoreAction) {
                                    triggerAction(learnMoreAction);
                                }
                            }, hitSlop: { top: 10, bottom: 10, left: 10, right: 10 } },
                            React.createElement(View, { style: Platform.OS !== 'web' ? { top: 5 } : {} },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ' Learn more', color: ColorTokens.Primary_100 }))))));
            }
        }
    };
    const renderConcentBox = () => {
        return (React.createElement(TouchableOpacity, { style: {
                padding: 16,
                zIndex: 1
            }, activeOpacity: 1, onPress: () => {
            } },
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, label: "Thank you for the confirmation" }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(View, { style: {
                        paddingTop: 2,
                    } },
                    React.createElement(Typography, { label: 'We are currently checking the latest status with lender, interest status will be updated once we receive their response.', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: { marginTop: 16 } },
                        React.createElement(Typography, { label: 'Note:', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: `${'\u2022'} We are currently checking the latest status with the lender, interest status will be updated once we receive their response.`, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: `${'\u2022'} Payment deducted via auto-debit accounted as paid on the due date.`, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal }))),
                React.createElement(View, { style: { marginTop: isMobileView() ? 24 : 68 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Ok, got it", fontSize: FontSizeTokens.SM, onPress: () => {
                            setShowPaymentConcentCard(false);
                        } })))));
    };
    const renderDeclinedBox = () => {
        return (React.createElement(View, { style: { padding: 16, height: 280 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Are you sure you want to pay\ninterest manually?' }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginTop: 16,
                } },
                React.createElement(View, null,
                    React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { marginLeft: 8 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Who should make manual payment?' }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: isMobileView() ? 'If your bank account is inactive or mandate has not been\nregistered' : 'If your bank account is inactive or mandate has not been registered' })),
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk })),
            React.createElement(View, { style: {
                    height: 1,
                    backgroundColor: '#F1F3F5',
                    width: '100%',
                    marginTop: 16,
                } }),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginTop: 16,
                } },
                React.createElement(View, null,
                    React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { marginLeft: 8 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'We will still attempt auto-debit' }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Any additional payments will be adjusted to your balance' }))),
            React.createElement(View, { style: Platform.OS !== 'web' ? { marginTop: 20 } : styles.successCTA },
                React.createElement(Button, { id: 'bt_autoPay_continue', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue', width: ButtonWidthTypeToken.FULL, loading: showButtonLoading, onPress: () => {
                        if (triggerAction) {
                            triggerAction(viewDetailAction);
                        }
                    } }))));
    };
    const renderSellOffBox = () => {
        return (React.createElement(View, { style: { padding: 16, height: 280 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Please Note' }),
            React.createElement(View, { style: {
                    marginTop: 16,
                } },
                React.createElement(View, null,
                    React.createElement(Text, { style: { flexShrink: 1 } },
                        React.createElement(Typography, { label: 'Lender might have initiated the portfolio sell-off to recover the overdue amount. ', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })),
                    React.createElement(Text, { style: { marginTop: 16, flexShrink: 1 } },
                        React.createElement(Typography, { label: 'You can contact our support team to check the sell-off status. ', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: { marginTop: 16 } },
                        React.createElement(Typography, { label: 'Or, you can proceed to pay overdue amount.Any additional payments will be adjusted to your principal balance.', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal })))),
            React.createElement(View, { style: { marginTop: isMobileView() ? 24 : 32 } },
                React.createElement(Button, { id: 'bt_autoPay_continue', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: `Continue`, width: ButtonWidthTypeToken.FULL, loading: showButtonLoading, onPress: () => {
                        if (triggerAction) {
                            triggerAction(viewDetailAction);
                        }
                    } }))));
    };
    const getDescriptionForNonMandate = () => {
        switch (type) {
            case InterestBounceType.NORMAL: {
                return (React.createElement(View, { style: isMandate ? styles.bottomNoteContainer : styles.bottomNoteContainerNonMandate },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_WARNING_DLS, size: IconSizeTokens.LG, color: ColorTokens.System_Warning })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(View, null,
                        React.createElement(Text, null,
                            React.createElement(Typography, { label: `Pay by `, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                            React.createElement(Typography, { label: `${softBreachDate}-${currentMonth} `, fontSize: FontSizeTokens.XS, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                            React.createElement(Typography, { label: `to avoid penalty charges`, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 })),
                        !areOnlyChargesDue && React.createElement(TouchableOpacity, { onPress: () => {
                                if (learnMoreAction) {
                                    triggerAction(learnMoreAction);
                                }
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Learn more', color: ColorTokens.Primary_100 })))));
            }
            case InterestBounceType.DATE_BREACHED: {
                return (React.createElement(View, { style: [isMandate ? styles.bottomNoteContainer : styles.bottomNoteContainerNonMandate, { backgroundColor: '#FFF8F8', }] },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.LG })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Text, null,
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Pay by`, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ` ${hardBreachDate}-${currentMonth}`, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: ` to avoid defaulting\n`, color: ColorTokens.Grey_Night }),
                        !areOnlyChargesDue && React.createElement(TouchableOpacity, { onPress: () => {
                                if (learnMoreAction) {
                                    triggerAction(learnMoreAction);
                                }
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Learn more', color: ColorTokens.Primary_100 })))));
            }
            case InterestBounceType.HARD_DATE_BREACHED: {
                return (React.createElement(View, { style: [isMandate ? styles.bottomNoteContainer : styles.bottomNoteContainerNonMandate, { backgroundColor: '#FFF8F8', }] },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.SM, color: ColorTokens.System_Error })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Text, { style: { flexShrink: 1 } },
                        React.createElement(Typography, { label: `Your interest is still overdue. Need help? `, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                if (contactSupportAction) {
                                    triggerAction(contactSupportAction);
                                }
                            } },
                            React.createElement(View, { style: Platform.OS !== 'web' ? { top: 5 } : {} },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Contact support', color: ColorTokens.Primary_100 }))))));
            }
            case InterestBounceType.BOUNCED: {
                return (React.createElement(View, { style: [isMandate ? styles.bottomNoteContainer : styles.bottomNoteContainerNonMandate, { backgroundColor: '#FFF8F8', }] },
                    React.createElement(View, { style: styles.mandateInfoImage },
                        React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.LG, color: ColorTokens.System_Error })),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Text, { style: { flexShrink: 1 } },
                        React.createElement(Typography, { label: `Last auto-debit failed! Pay by ${hardBreachDate} ${currentMonth} to avoid defaulting`, fontSize: FontSizeTokens.XS, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, lineHeight: 18 }),
                        !areOnlyChargesDue && React.createElement(TouchableOpacity, { onPress: () => {
                                if (learnMoreAction) {
                                    triggerAction(learnMoreAction);
                                }
                            } },
                            React.createElement(View, { style: Platform.OS !== 'web' ? { top: 5 } : {} },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: ' Learn more', color: ColorTokens.Primary_100 }))))));
            }
        }
    };
    const body = () => {
        return (React.createElement(View, { style: styles.bodyContainer },
            React.createElement(View, { style: { flexDirection: 'row', padding: 16 } },
                React.createElement(View, { style: styles.circle },
                    React.createElement(Icon, { name: IconTokens.SYSTEM_RUPEE_DLS, size: IconSizeTokens.XXL })),
                React.createElement(View, { style: { marginLeft: 12 } },
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal, label: type === InterestBounceType.HARD_DATE_BREACHED || type === InterestBounceType.BOUNCED ? 'Amount overdue' : 'Amount due' })),
                    React.createElement(View, { style: { flexDirection: 'row' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, label: `₹${addCommasToNumber(interestRepaymentData.totalAmount)}` }),
                        isFromTata && React.createElement(TouchableOpacity, { style: { marginLeft: 4, marginBottom: 4 }, onPress: () => {
                                setShowBreakupModal(true);
                            } },
                            React.createElement(Icon, { name: IconTokens.SYSTEM_INFO_DLS, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night }))))),
            React.createElement(View, { style: { paddingHorizontal: 17 } },
                React.createElement(View, { style: {
                        width: '100%',
                        height: 1,
                        backgroundColor: '#F1F3F5',
                        marginBottom: 17,
                    } })),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    paddingHorizontal: 16,
                } },
                React.createElement(View, { style: styles.circle },
                    React.createElement(Icon, { name: IconTokens.SYSTEM_CALENDAR_DLS, size: IconSizeTokens.XXL })),
                React.createElement(View, { style: { marginLeft: 12, } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal, label: 'Month' }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, label: `${interestRepaymentData.month}, ${interestRepaymentData.year}` }))),
            React.createElement(View, { style: { paddingHorizontal: 17 } },
                React.createElement(View, { style: {
                        width: '100%',
                        height: 1,
                        backgroundColor: '#F1F3F5',
                        marginVertical: 17,
                    } })),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    paddingHorizontal: 16,
                } },
                React.createElement(View, { style: styles.circle },
                    React.createElement(Icon, { name: IconTokens.CALENDAR_ARROW, size: IconSizeTokens.XXL })),
                React.createElement(View, { style: { marginLeft: 12 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal, label: !interestRepaymentData.isMandateSetup ? 'Due date' : 'Auto-debit date' }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, label: `${convertEpochToCustomFormat(interestRepaymentData.autoPayDate)}` }))),
            React.createElement(View, { style: { margin: 16 } },
                React.createElement(View, { style: styles.bankCardContainer },
                    interestRepaymentData.isMandateSetup && React.createElement(View, { style: styles.bankDetailsCard },
                        React.createElement(View, { style: styles.accountDetails },
                            React.createElement(View, { style: styles.accountContent },
                                React.createElement(Typography
                                // @ts-ignore
                                , { 
                                    // @ts-ignore
                                    label: `${bankDetail.bankName}`, fontWeight: '400', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, lineHeight: 20 }),
                                React.createElement(Space, { size: SizeTypeTokens.SM }),
                                React.createElement(Typography, { label: `XXXX ${bankaccountNumber}`, fontWeight: '600', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, lineHeight: 24 }),
                                React.createElement(Space, { size: SizeTypeTokens.LG })),
                            React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankDetail.bankCode}.png`, size: ImageSizeTokens.SIZE_40, defaultUri: 'https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png' }))),
                    React.createElement(View, { style: interestRepaymentData.isMandateSetup ? styles.lineStyle : { borderTopRightRadius: 12, borderTopLeftRadius: 12 } }),
                    !interestRepaymentData.isMandateSetup ? getDescriptionForNonMandate() : getDescription()))));
    };
    const renderMandateStatusCard = () => {
        return (showPayModal && (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: type === InterestBounceType.HARD_DATE_BREACHED ? 500 : 280, closeFunction: () => {
                    setShowPayModal(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, renderPayNowInfo()))));
    };
    const renderPaymentConsentCard = () => {
        return (showPaymentConcentCard && (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: showPaymentDeclined ? 300 : 340, closeFunction: () => {
                    setShowPaymentConcentCard(false);
                    setShowPaymentDeclined(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, showPaymentDeclined ? renderDeclinedBox() : renderConcentBox()))));
    };
    const renderSellOffWarning = () => {
        return (showSellOffCard && (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: isMobileView() ? 340 : 280, closeFunction: () => {
                    setShowSellOffCard(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, renderSellOffBox()))));
    };
    const renderOutstandingBreakup = () => {
        return (showBreakupModal && (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 300, closeFunction: () => {
                    setShowBreakupModal(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, renderInfoBox()))));
    };
    const renderInfoBox = () => {
        return (React.createElement(TouchableOpacity, { style: {
                padding: 16,
                zIndex: 1
            }, activeOpacity: 1, onPress: () => {
            } },
            React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 24, label: "Total due" }),
            React.createElement(View, { style: { marginTop: 24, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8, padding: 12 } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(Typography, { label: 'Outstanding interest', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(interestRepaymentData.outstandingInterest), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: "#E4E7EC", marginTop: 16 } }),
                React.createElement(View, { style: {
                        marginTop: 12,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(View, { style: { flexDirection: "row" } },
                            React.createElement(Typography, { label: 'Outstanding charges', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', color: ColorTokens.Grey_Charcoal }),
                            React.createElement(TouchableOpacity, { style: { marginLeft: 4 }, onPress: () => {
                                } }))),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(interestRepaymentData.outStandingCharges), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '500', color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { height: 1, width: '100%', backgroundColor: "#E4E7EC", marginTop: 16 } }),
                React.createElement(View, { style: {
                        marginTop: 16,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        paddingTop: 2,
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: 'Total', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night })),
                    React.createElement(Typography, { label: '₹' + addCommasToNumber(interestRepaymentData.totalAmount), fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '600', color: ColorTokens.Grey_Night }))),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Ok, got it!", fontSize: FontSizeTokens.SM, onPress: () => {
                        setShowBreakupModal(false);
                    } }))));
    };
    const renderPayNowInfo = () => {
        switch (type) {
            case InterestBounceType.NORMAL:
                return (React.createElement(View, { style: { padding: 16, height: 280 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Are you sure you want to pay\ninterest manually?' }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 16,
                        } },
                        React.createElement(View, null,
                            React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS, color: ColorTokens.Grey_Night })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Who should make manual payment?' }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: isMobileView() ? 'If your bank account is inactive or mandate has not been\nregistered' : 'If your bank account is inactive or mandate has not been registered' })),
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk })),
                    React.createElement(View, { style: {
                            height: 1,
                            backgroundColor: '#F1F3F5',
                            width: '100%',
                            marginTop: 16,
                        } }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 16,
                        } },
                        React.createElement(View, null,
                            React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS, color: ColorTokens.Grey_Night })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'We will still attempt auto-debit' }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Any additional payments will be adjusted to your balance' }))),
                    React.createElement(View, { style: Platform.OS !== 'web' ? { marginTop: 20 } : styles.successCTA },
                        React.createElement(Button, { id: 'bt_autoPay_continue', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: `Continue`, width: ButtonWidthTypeToken.FULL, loading: showButtonLoading, onPress: () => {
                                if (triggerAction) {
                                    triggerAction(viewDetailAction);
                                }
                            } }))));
            case InterestBounceType.DATE_BREACHED:
                return (React.createElement(View, { style: { padding: 16, height: 280 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Are you sure you want to pay interest manually?' }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 16,
                        } },
                        React.createElement(View, null,
                            React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Who should make manual payment?' }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'If your bank account is inactive or mandate has not been registered' })),
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk })),
                    React.createElement(View, { style: {
                            height: 1,
                            backgroundColor: '#F1F3F5',
                            width: '100%',
                            marginTop: 16,
                        } }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 16,
                        } },
                        React.createElement(View, null,
                            React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'We will still attempt auto-debit' }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Any additional payments will be adjusted to your balance' }))),
                    React.createElement(View, { style: Platform.OS !== 'web' ? { marginTop: 20 } : styles.successCTA },
                        React.createElement(Button, { id: 'bt_autoPay_continue', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: `Continue`, width: ButtonWidthTypeToken.FULL, loading: showButtonLoading, onPress: () => {
                                if (triggerAction) {
                                    triggerAction(viewDetailAction);
                                }
                            } }))));
            case InterestBounceType.HARD_DATE_BREACHED:
                return (React.createElement(View, { style: { padding: 16, height: 500, } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'What happens if you fail to pay' }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 32,
                        } },
                        React.createElement(View, null,
                            React.createElement(Icon, { name: IconTokens.SYSTEM_RUPEE_DLS })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Chance of initiating portfolio sell-off' }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Portfolio sell-off will be initiated to recover outstanding interest if you fail to pay\nwithin 7 days of due date' }))),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                    React.createElement(View, { style: {
                            height: 1,
                            backgroundColor: '#F1F3F5',
                            width: '100%',
                            marginTop: 16,
                        } }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 16,
                        } },
                        React.createElement(View, null,
                            React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Penal interest @2% per month' }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Penal interest will be applied on outstanding interest until you settle the\noutstanding amount' }))),
                    React.createElement(View, { style: { marginTop: 16 } }),
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Milk }),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            marginTop: 16,
                        } },
                        React.createElement(View, null,
                            React.createElement(Icon, { name: IconTokens.SYSTEM_DONE_DLS })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Impact on credit score' }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Not making payments on time can affect your credit score' }))),
                    React.createElement(View, { style: { padding: 12, backgroundColor: '#FDF7E7', marginTop: 26, flexDirection: 'row' } },
                        React.createElement(View, { style: {
                                width: 24,
                                height: 24,
                                borderRadius: 24 / 2,
                                backgroundColor: '#FCC026',
                                justifyContent: 'center',
                                alignContent: 'center',
                                alignItems: 'center'
                            } },
                            React.createElement(Icon, { name: IconTokens.BulbOutline, size: IconSizeTokens.SM, color: ColorTokens.White })),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: 'Tip:' }),
                            React.createElement(Text, null,
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Maintain balance in your account\nXXXX ${bankaccountNumber} to avoid bounce charges` })))),
                    React.createElement(View, { style: styles.successCTA },
                        React.createElement(Button, { id: 'bt_autoPay_continue', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: `Continue`, width: ButtonWidthTypeToken.FULL, loading: false, onPress: () => {
                                if (triggerAction) {
                                    triggerAction(viewDetailAction);
                                }
                            } }))));
        }
    };
    const getFooterText = () => {
        if (type === InterestBounceType.NORMAL || type === InterestBounceType.DATE_BREACHED)
            return "";
    };
    const footerAwaiting = () => {
        console.warn("TYPE IS", type, interestRepaymentData.isMandateSetup, showButtonLoading);
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLoading: showButtonLoading, btnLabel: "No", onPress: () => {
                setShowPaymentConcentCard(true);
                setShowPaymentDeclined(true);
            }, btnTypeDLS: ButtonTypeDLS.SECONDARY, isPositionAbsolute: false, children: (true) ?
                React.createElement(View, { style: {
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, textAlign: TextAlignTokens.center, label: 'Is your amount debited?' }),
                    React.createElement(View, { style: { marginTop: 16 } }),
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, label: "Yes", fontSize: FontSizeTokens.SM, onPress: () => {
                            setShowPaymentConcentCard(true);
                        } })) : React.createElement(React.Fragment, null,
                React.createElement(View, { style: {
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row',
                    } },
                    React.createElement(Text, { style: { textAlign: 'center' } },
                        (type === InterestBounceType.NORMAL) && interestRepaymentData.isMandateSetup && React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, textAlign: TextAlignTokens.center, label: 'Is bank account inactive or mandate not\nregistered? ' }),
                        type !== InterestBounceType.HARD_DATE_BREACHED && type !== InterestBounceType.BOUNCED && interestRepaymentData.isMandateSetup && React.createElement(TouchableOpacity, { onPress: () => {
                                setShowPayModal(true);
                            } },
                            React.createElement(View, { style: Platform.OS !== 'web' ? { alignSelf: 'center', top: 4 } : { alignSelf: 'center' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Primary_100, textAlign: TextAlignTokens.center, label: 'Pay now' })))))) }));
    };
    const footer = () => {
        // console.warn("TYPE IS",type, interestRepaymentData.isMandateSetup, showButtonLoading)
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLoading: showButtonLoading, btnLabel: (type === InterestBounceType.NORMAL || type === InterestBounceType.DATE_BREACHED) && interestRepaymentData.isMandateSetup ? 'Ok, got it!' : interestRepaymentData.repaymentAllowed ? `Continue` : 'Contact support', onPress: () => {
                if (triggerAction) {
                    if (!interestRepaymentData.repaymentAllowed) {
                        triggerAction(contactSupportAction);
                    }
                    else {
                        if ((type === InterestBounceType.NORMAL || type === InterestBounceType.DATE_BREACHED) && interestRepaymentData.isMandateSetup) {
                            triggerAction(backAction);
                        }
                        else {
                            if (viewDetailAction && type !== InterestBounceType.HARD_DATE_BREACHED) {
                                setButtonLoading(true);
                                triggerAction(viewDetailAction);
                            }
                            else {
                                setShowSellOffCard(true);
                            }
                        }
                    }
                }
            }, btnTypeDLS: ButtonTypeDLS.PRIMARY, isPositionAbsolute: false, children: React.createElement(React.Fragment, null,
                React.createElement(View, { style: {
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row',
                    } },
                    React.createElement(Text, { style: { textAlign: 'center' } },
                        (type === InterestBounceType.NORMAL || type === InterestBounceType.DATE_BREACHED) && interestRepaymentData.isMandateSetup && React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, textAlign: TextAlignTokens.center, label: 'Is bank account inactive or mandate not\nregistered? ' }),
                        type !== InterestBounceType.HARD_DATE_BREACHED && type !== InterestBounceType.BOUNCED && interestRepaymentData.isMandateSetup && React.createElement(TouchableOpacity, { onPress: () => {
                                setShowPayModal(true);
                            } },
                            React.createElement(View, { style: Platform.OS !== 'web' ? { alignSelf: 'center', top: 4 } : { alignSelf: 'center' } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Primary_100, textAlign: TextAlignTokens.center, label: 'Pay now' })))))) }));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: React.createElement(React.Fragment, null, header()), bottomChildren: React.createElement(React.Fragment, null,
            type === InterestBounceType.DATE_BREACHED && interestRepaymentData.isMandateSetup ? footerAwaiting() : footer(),
            renderMandateStatusCard(),
            renderOutstandingBreakup(),
            renderPaymentConsentCard(),
            renderSellOffWarning()) },
        React.createElement(React.Fragment, null, body())));
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16,
    },
    bodyContainer: {
        justifyContent: 'center',
        width: '100%',
        flexDirection: 'column',
        flex: 1,
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    circle: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#F3F5FC',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 24,
        }),
    },
    successCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        marginTop: 24,
        position: 'absolute',
        bottom: 0,
        marginBottom: 16,
        width: '94%'
    },
    bottomNoteContainer: {
        backgroundColor: '#FDF7E7',
        flexDirection: 'row',
        padding: 12,
        borderBottomRightRadius: 12,
        borderTopWidth: 0.5,
        borderColor: '#E4E7EC',
        borderBottomLeftRadius: 12,
        justifyContent: 'flex-start',
    },
    bottomNoteContainerNonMandate: {
        backgroundColor: '#FDF7E7',
        flexDirection: 'row',
        padding: 12,
        borderBottomRightRadius: 12,
        borderTopRightRadius: 12,
        borderTopLeftRadius: 12,
        borderTopWidth: 0.5,
        borderColor: '#E4E7EC',
        borderBottomLeftRadius: 12,
        justifyContent: 'flex-start',
    },
    modalView: {
        justifyContent: 'flex-end',
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1,
    },
    failureCard: {
        alignItems: 'center',
        flex: 1,
        height: 270,
        padding: 16,
        justifyContent: 'space-between',
    },
    userCancelledCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
        justifyContent: 'space-between',
    },
    whyAutoPay: {
        flex: 1,
        padding: 16,
        justifyContent: 'space-between',
    },
    whyAutoPayDesc: { marginTop: -24 },
    whyAutoPayCTA: {
        width: '100%',
        alignItems: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        justifyContent: 'flex-end',
    },
    errorCTA: {
        width: '100%',
        marginTop: 16,
        flexDirection: 'column',
    },
    landingTitle: {
        marginTop: 24,
        marginBottom: 16,
    },
    bankDetailsCard: {
        paddingTop: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 12,
    },
    accountDetails: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    accountContent: {
        width: 180,
        flexDirection: 'column',
    },
    autoDebitCard: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16,
    },
    mandateInfoImage: { marginTop: 2 },
    lineStyle: {
        borderWidth: 0.1,
        borderColor: '#E4E7EC',
    },
    bankCardContainer: {
        width: '100%',
        borderWidth: 1,
        borderRadius: 12,
        borderColor: '#E4E7EC',
        flexDirection: 'column',
        alignSelf: 'center',
    },
});
// @ts-ignore
export default InterestRepaymentDetails;
